




























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import { Loading } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import ChatFinanceiroStore from '@/components/financeiro-chat/store/chat-financeiro-store'
import AntecipacaoRecebiveisStore from '@/components/RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'
import { getSnackbarMessage, maskMoney, maskDateTime } from '@/utils/common'

type PainelRecebimento = 'listagem' | 'relatorio' | null

@Component

export default class ViewRecebimento extends Vue {
  listEmpty: boolean = false
  loadEmitirRelatorio: boolean = false
  painelAberto: PainelRecebimento = null

  modalCarteira: boolean = false
  modalHistorico: boolean = false

  loading: Loading = {
    status: false,
    text: '',
  }

  get isUserFinx(): boolean {
    const user = [
      // 'sergio.campangna@finxapp.com.br',
      'mario.campangna@finxapp.com.br',
    ]
    return user.includes(this.$user.profile.preferredUsername)
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getAntecipacaoStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get recebimentos() {
    return this.getRecebimentoStore.recebimentos
  }

  get podeAntecipar() {
    return this.getAntecipacaoStore.podeAntecipar
  }

  set podeAntecipar(value: boolean) {
    this.getAntecipacaoStore.setPodeAntecipar(value)
  }

  async getRelatorio() {
    this.setLoadingRequest(true, this.getRequestMessage.init.text)
    await this.getRecebimentoStore.loadRecebimentos()
    this.validListEmpty()
    this.clearLoadingRequest()
  }

  get getListEmpty() {
    return this.listEmpty
  }

  get loadingEmitirRelatorio() { return this.loadEmitirRelatorio }
  set loadingEmitirRelatorio(value: boolean) { this.loadEmitirRelatorio = value }

  get painelListagemAberto(): boolean {
    return this.painelAberto === 'listagem'
  }

  get painelRelatorioAberto(): boolean {
    return this.painelAberto === 'relatorio'
  }

  get iconeBotaoRelatorio(): string {
    if (this.painelRelatorioAberto) {
      return 'close'
    }

    return 'las la-file-invoice'
  }

  get iconeBotaoFiltros(): string {
    if (this.painelListagemAberto) {
      return 'close'
    }

    return 'search'
  }

  get qtdFiltrosListagem(): number {
    const { fontePagadoraSelected, anoMesReferenciaDeSelected, anoMesReferenciaAteSelected } = this.getRecebimentoStore
    const periodo = anoMesReferenciaDeSelected || anoMesReferenciaAteSelected

    if (periodo) {
      return fontePagadoraSelected.length + 1
    }

    return fontePagadoraSelected.length
  }

  get temFiltroListagemAtivo(): boolean {
    return this.qtdFiltrosListagem > 0
  }

  alternarPainelListagem() {
    this.painelAberto = this.painelListagemAberto ? null : 'listagem'
  }

  fecharPainel() {
    this.painelAberto = null
  }

  get modelSituacoesRecebimento() {
    return this.getRecebimentoStore.situacaoRecebimento
  }

  set modelSituacoesRecebimento(value: string) {
    this.getRecebimentoStore.setSituacaoRecebimento(value)
  }

  get situacoesRecebimento() {
    return [
      { text: 'Todos', value: 'Todos' },
      { text: 'Recebido', value: 'Recebido' },
      { text: 'A receber', value: 'AReceber' },
    ]
  }

  set getListEmpty(value: boolean) {
    this.listEmpty = value
  }

  maskMoney(value: any) {
    return maskMoney(value)
  }

  maskDate(value: any) {
    return maskDateTime(value)
  }

  get valorTotal(): number | null {
    return this.getAntecipacaoStore.valorTotal
  }

  get valorTotalLabel(): string {
    if (this.valorTotal === null || this.valorTotal === undefined) {
      return 'Disponível para antecipação: indisponível no momento'
    }
    return `Disponível para antecipação: ${maskMoney(String(this.valorTotal))}`
  }

  get saldoZerado(): boolean {
    return this.valorTotal === 0
  }

  get saldoTooltip(): string {
    return 'Aguardando a próxima avaliação de crédito para saldo de antecipações'
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loading.status = status
    this.loading.text = text
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  get getRequestMessage() {
    return this.getRecebimentoStore.requestMessage
  }

  validListEmpty() {
    this.getListEmpty = this.recebimentos ? this.recebimentos.length === 0 : false
  }

  get relatorios() {
    return this.getRecebimentoStore.relatorios
  }

  get podeEmitirRelatorio() {
    return this.getRecebimentoStore.podeEmitirRelatorio
  }

  get documentoProfissional() {
    return this.getRecebimentoStore.documentoProfissional
  }

  openModalAntecipacao() {
    this.modalCarteira = true
    this.getAntecipacaoStore.getAntecipacaoProfissional()
  }

  get antecipacoesDisponiveis(): any[] {
    const emAndamento = ['solicitado', 'negociacao', 'aprovado', 'reprovado']
    return (this.getAntecipacaoStore.antecipacaoProfissional || []).filter((item: any) => {
      const status = item && item.status ? String(item.status).toLowerCase() : ''
      return !emAndamento.includes(status)
    })
  }

  openModalHistorico() {
    this.modalHistorico = true
  }

  irParaHistorico() {
    this.openModalHistorico()
  }

  async atualizarDisponiveis() {
    await this.getAntecipacaoStore.getAntecipacaoProfissional()
    if (!this.antecipacoesDisponiveis.length) {
      this.modalCarteira = false
    }
  }

  openMockAntecipacao() {
    this.getAntecipacaoStore.setShowAntecipacaoMock(true)
  }

  async emitirRelatorio() {
    if (this.painelRelatorioAberto) {
      this.fecharPainel()
      return
    }

    this.loadingEmitirRelatorio = true
    const [fontesPagadora, relatorios] = await Promise.all([
      this.getRecebimentoStore.getFontePagadoraLoggedUser(),
      this.getRecebimentoStore.getRelatoriosByFontePagadora(),
    ])
    this.loadingEmitirRelatorio = false

    if (!fontesPagadora.success || !relatorios.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Não é possível emitir um relatório no momento. Tente novamente mais tarde.', 'error'))
      return
    }

    this.painelAberto = 'relatorio'
  }

  async init() {
    this.setLoadingRequest(true, this.getRequestMessage.init.text)
    await this.getRecebimentoStore.recebimentoAcoes()
    await this.getRecebimentoStore.loadRecebimentos()
    this.getAntecipacaoStore.setDocumentoProfissional(this.documentoProfissional)
    await this.getAntecipacaoStore.getAntecipacaoProfissional()
    this.validListEmpty()
    this.clearLoadingRequest()
  }

  get chatStore() {
    return getModule(ChatFinanceiroStore, this.$store)
  }

  async mounted() {
    await this.init()
    EventBus.$on('receberMensagemChatRemuneracao', async (data: any) => {
      this.chatStore.addMessage(data)
    })
  }

  @Watch('modelSituacoesRecebimento')
  async onSituacaoRecebimentoChange(value: string) {
    this.setLoadingRequest(true, this.getRequestMessage.init.text)
    await this.getRecebimentoStore.loadRecebimentos()
    this.validListEmpty()
    this.clearLoadingRequest()
  }

  @Watch('painelAberto')
  onPainelAbertoChange(atual: PainelRecebimento, anterior: PainelRecebimento) {
    if (anterior !== 'relatorio') {
      return
    }

    this.getRecebimentoStore.clearFontesPagadoras()
    this.getRecebimentoStore.clearFontePagadora()
    this.getRecebimentoStore.clearRelatorios()
    this.getRecebimentoStore.clearRelatorio()
    this.getRecebimentoStore.clearAnoMesReferencia()
  }
}
